module.exports = __webpack_public_path__ + "static/media/MoreVerticalSmall.3b6a2445.svg";